import {
  START_LOADING,
  STOP_LOADING,
  ERROR,
  SUCCESS,
  RESET,
  GET_TIME_TYPE_LIST,
} from "../types/index.js";

const initialState = {
  IsError: false,
  isSuccess: false,
  isLoading: false,
  TimeList: undefined,
};

const TimeTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case STOP_LOADING:
      return { ...state, isLoading: false };
    case GET_TIME_TYPE_LIST:
      return {
        ...state,
        TimeList: action.payload,
      };
    case RESET:
      return { ...initialState };
    case ERROR:
      return { ...state, IsError: true, isSuccess: false };
    case SUCCESS:
      return { ...state, IsError: false, isSuccess: true };
    default:
      return state;
  }
};
export default TimeTypeReducer;
